var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.filterFold ? "展开筛选" : "收起筛选") +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _vm.resData
                      ? _c(
                          "div",
                          { staticStyle: { padding: "10px 25px" } },
                          [
                            _c(
                              "el-form",
                              {
                                ref: "form",
                                attrs: {
                                  model: _vm.form,
                                  "label-width": "85px"
                                }
                              },
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 10 } },
                                  [
                                    _c(
                                      "el-col",
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "输入搜索：" } },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 2 } },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    placeholder: "次品员"
                                                  },
                                                  nativeOn: {
                                                    keyup: function($event) {
                                                      if (
                                                        !$event.type.indexOf(
                                                          "key"
                                                        ) &&
                                                        _vm._k(
                                                          $event.keyCode,
                                                          "enter",
                                                          13,
                                                          $event.key,
                                                          "Enter"
                                                        )
                                                      ) {
                                                        return null
                                                      }
                                                      return _vm.search.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value: _vm.form.admin_name,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "admin_name",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.admin_name"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 2 } },
                                              [
                                                _vm.resData
                                                  ? _c(
                                                      "el-select",
                                                      {
                                                        attrs: {
                                                          placeholder: "次品组",
                                                          filterable: ""
                                                        },
                                                        model: {
                                                          value: _vm.form.dgid,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.form,
                                                              "dgid",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "form.dgid"
                                                        }
                                                      },
                                                      [
                                                        _c("el-option", {
                                                          attrs: {
                                                            label: "全部",
                                                            value: ""
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          _vm.resData.options
                                                            .group,
                                                          function(item) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: item.value,
                                                                attrs: {
                                                                  value:
                                                                    item.value,
                                                                  label:
                                                                    item.label
                                                                }
                                                              }
                                                            )
                                                          }
                                                        )
                                                      ],
                                                      2
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 3 } },
                                              [
                                                _vm.resData
                                                  ? _c(
                                                      "el-select",
                                                      {
                                                        attrs: {
                                                          placeholder: "城市",
                                                          filterable: ""
                                                        },
                                                        model: {
                                                          value: _vm.form.city,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.form,
                                                              "city",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "form.city"
                                                        }
                                                      },
                                                      [
                                                        _c("el-option", {
                                                          attrs: {
                                                            label: "全部",
                                                            value: ""
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          _vm.resData.options
                                                            .city,
                                                          function(item) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: item.value,
                                                                attrs: {
                                                                  value:
                                                                    item.value,
                                                                  label:
                                                                    item.label
                                                                }
                                                              }
                                                            )
                                                          }
                                                        )
                                                      ],
                                                      2
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 3 } },
                                              [
                                                _vm.resData
                                                  ? _c(
                                                      "el-select",
                                                      {
                                                        attrs: {
                                                          placeholder: "角色",
                                                          filterable: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.form.character,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.form,
                                                              "character",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "form.character"
                                                        }
                                                      },
                                                      [
                                                        _c("el-option", {
                                                          attrs: {
                                                            label: "全部",
                                                            value: ""
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          _vm.resData.options
                                                            .character,
                                                          function(item) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: item.value,
                                                                attrs: {
                                                                  value:
                                                                    item.value,
                                                                  label:
                                                                    item.label
                                                                }
                                                              }
                                                            )
                                                          }
                                                        )
                                                      ],
                                                      2
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 3 } },
                                              [
                                                _vm.resData
                                                  ? _c(
                                                      "el-select",
                                                      {
                                                        attrs: {
                                                          placeholder:
                                                            "成员身份",
                                                          filterable: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.form.role_type,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.form,
                                                              "role_type",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "form.role_type"
                                                        }
                                                      },
                                                      [
                                                        _c("el-option", {
                                                          attrs: {
                                                            label: "全部",
                                                            value: ""
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          _vm.constantMap
                                                            .membershipOptions,
                                                          function(item) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: item.value,
                                                                attrs: {
                                                                  value:
                                                                    item.value,
                                                                  label:
                                                                    item.label
                                                                }
                                                              }
                                                            )
                                                          }
                                                        )
                                                      ],
                                                      2
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 3 } },
                                              [
                                                _vm.resData
                                                  ? _c(
                                                      "el-select",
                                                      {
                                                        attrs: {
                                                          placeholder: "状态"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.form.status,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.form,
                                                              "status",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "form.status"
                                                        }
                                                      },
                                                      [
                                                        _c("el-option", {
                                                          attrs: {
                                                            label: "全部",
                                                            value: ""
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          _vm.resData.options
                                                            .status,
                                                          function(item) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: item.value,
                                                                attrs: {
                                                                  label:
                                                                    item.label,
                                                                  value:
                                                                    item.value
                                                                }
                                                              }
                                                            )
                                                          }
                                                        )
                                                      ],
                                                      2
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 6 } },
                                              [
                                                _c("el-date-picker", {
                                                  attrs: {
                                                    type: "daterange",
                                                    "value-format":
                                                      "yyyy-MM-dd",
                                                    "range-separator": "至",
                                                    "start-placeholder":
                                                      "开始日期",
                                                    "end-placeholder":
                                                      "结束日期"
                                                  },
                                                  model: {
                                                    value: _vm.form.create_time,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "create_time",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.create_time"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 2 } },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: { type: "primary" },
                                                    on: { click: _vm.search }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        查询"
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _vm.resData
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      background: "#f3f3f3",
                      height: "50px",
                      "line-height": "30px",
                      padding: "0 25px",
                      display: "flex",
                      "align-items": "center"
                    }
                  },
                  [
                    _c("div", [
                      _vm._v("数据汇总 ：" + _vm._s(_vm.resData.count) + "人")
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "auto" },
                        attrs: { type: "warning", size: "mini" },
                        on: { click: _vm.AddMember }
                      },
                      [_vm._v("创建次品员\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success", size: "mini" },
                        on: { click: _vm.output }
                      },
                      [_vm._v("导出")]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "margin-bottom": "0" } },
                  [
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.tableLoading,
                            expression: "tableLoading"
                          }
                        ],
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          height: "600",
                          data: _vm.resData.list,
                          "tooltip-effect": "dark"
                        },
                        on: { "selection-change": _vm.handleSelectionChange }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "dg_member_id",
                            label: "次品员id",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "admin_name",
                            label: "次品员",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "defective_group_member_character",
                            label: "角色",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "role_type",
                            label: "成员身份",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.constantMap.membershipOptions.find(
                                            function(item) {
                                              return (
                                                item.value === row.role_type
                                              )
                                            }
                                          ).label
                                        )
                                      )
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1039584225
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "group_names",
                            label: "次品组",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "defective_group_member_city",
                            label: "城市",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "supply_num",
                            label: "绑定商家数量",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "defective_group_member_status",
                            label: "状态",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "create_time",
                            label: "创建时间",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "",
                            label: "操作",
                            align: "center",
                            width: "100"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { size: "small", type: "text" },
                                        on: {
                                          click: function($event) {
                                            return _vm.editMember(
                                              scope.row.dg_member_id
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("编辑")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { size: "small", type: "text" },
                                        on: {
                                          click: function($event) {
                                            return _vm.showLogList(
                                              scope.row.dg_member_id
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("操作日志\n              ")]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1001948591
                          )
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.resData.page,
                        background: "",
                        layout: "total, prev, sizes,pager, next, jumper ",
                        total: _vm.resData.count,
                        "page-size": 50,
                        "page-sizes": [10, 50, 100]
                      },
                      on: {
                        "update:currentPage": function($event) {
                          return _vm.$set(_vm.resData, "page", $event)
                        },
                        "update:current-page": function($event) {
                          return _vm.$set(_vm.resData, "page", $event)
                        },
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.handleCurrentChange
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加/编辑次品员",
            width: "20%",
            visible: _vm.showbox,
            "before-close": _vm.closeEditDefectiveMember
          },
          on: {
            "update:visible": function($event) {
              _vm.showbox = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "memberRef",
              attrs: {
                model: _vm.member_form,
                "label-width": "100px",
                "label-position": "left",
                rules: _vm.memberFormRules
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "次品员", prop: "admin_id" } },
                [
                  !_vm.admin_disabled
                    ? _c(
                        "el-select",
                        {
                          attrs: { id: "no_member", filterable: "" },
                          model: {
                            value: _vm.member_form.admin_id,
                            callback: function($$v) {
                              _vm.$set(_vm.member_form, "admin_id", $$v)
                            },
                            expression: "member_form.admin_id"
                          }
                        },
                        _vm._l(_vm.options.admin, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value }
                          })
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.admin_disabled
                    ? _c(
                        "el-select",
                        {
                          attrs: { id: "has_member", disabled: "" },
                          model: {
                            value: _vm.member_form.admin_id,
                            callback: function($$v) {
                              _vm.$set(_vm.member_form, "admin_id", $$v)
                            },
                            expression: "member_form.admin_id"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.member_form.admin_name,
                              value: _vm.member_form.admin_id
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "角色", prop: "character" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "" },
                      model: {
                        value: _vm.member_form.character,
                        callback: function($$v) {
                          _vm.$set(_vm.member_form, "character", $$v)
                        },
                        expression: "member_form.character"
                      }
                    },
                    _vm._l(_vm.options.character, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "成员身份", prop: "role_type" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "" },
                      model: {
                        value: _vm.member_form.role_type,
                        callback: function($$v) {
                          _vm.$set(_vm.member_form, "role_type", $$v)
                        },
                        expression: "member_form.role_type"
                      }
                    },
                    _vm._l(_vm.constantMap.membershipOptions, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "绑定城市", prop: "city" } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.member_form.city,
                        callback: function($$v) {
                          _vm.$set(_vm.member_form, "city", $$v)
                        },
                        expression: "member_form.city"
                      }
                    },
                    _vm._l(_vm.options.city, function(item) {
                      return _c("el-option", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: item.value > 0,
                            expression: "item.value > 0"
                          }
                        ],
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "绑定次品组", prop: "dgids" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", multiple: "" },
                      model: {
                        value: _vm.member_form.dgids,
                        callback: function($$v) {
                          _vm.$set(_vm.member_form, "dgids", $$v)
                        },
                        expression: "member_form.dgids"
                      }
                    },
                    _vm._l(_vm.options.group, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "status" } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.member_form.status,
                        callback: function($$v) {
                          _vm.$set(_vm.member_form, "status", $$v)
                        },
                        expression: "member_form.status"
                      }
                    },
                    _vm._l(_vm.options.status, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: { click: _vm.closeEditDefectiveMember }
                },
                [_vm._v("\n        取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.saveDefectiveMember }
                },
                [_vm._v("\n        确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { "before-close": _vm.closeLogBox, visible: _vm.showlog },
          on: {
            "update:visible": function($event) {
              _vm.showlog = $event
            }
          }
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.loglist, height: "250" }
            },
            [
              _c("el-table-column", {
                attrs: { fixed: "", prop: "action_type", label: "事件" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { width: "350", label: "内容", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", {
                          domProps: { innerHTML: _vm._s(scope.row.action_desc) }
                        })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "action_admin", label: "操作人" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "create_time", label: "操作时间" }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ca86d9c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca86d9c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/defectivegroup/member.vue
// module id = null
// module chunks = 